import React from 'react'
import { Field } from 'redux-form'
import { TextField } from '@foodsby/nutrient'
import LinkPopup from '../common/LinkPopup'
import PrivacyPolicy from '../legal/PrivacyPolicy'
import TermsOfUse from '../legal/TermsOfUse'

import {
  required,
  email,
  confirmation,
  length
} from 'redux-form-validators/lib'

import { loginRoute } from '../../routes/routes'

export const RegisterExtraButtons = props => (
  <div className="row center-xs">
    <div className="col-xs">
      <a href={loginRoute.path}>Already a user? Login</a>
    </div>
  </div>
)

const RegisterForm = ({ error, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    {error && <div className="row error center-xs">{error}</div>}
    <div className="row center-xs">
      <div className="col-xs-12">
        <Field
          id="username"
          name="username"
          type="email"
          component={TextField}
          label="Email *"
          validate={[
            required({ msg: `Email is required` }),
            email(),
            length({ max: 254 })
          ]}
        />
      </div>
      <div className="col-xs-12 _lr-hide">
        <Field
          id="password"
          name="password"
          type="password"
          component={TextField}
          label="Create Password *"
          validate={[
            required({ msg: `Password is required` }),
            length({ min: 8 })
          ]}
        />
      </div>
      <div className="col-xs-12 _lr-hide">
        <Field
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          component={TextField}
          label="Confirm Password *"
          validate={[
            required({ msg: `Confirm Password is required` }),
            confirmation({ field: 'password', fieldLabel: 'Password' })
          ]}
        />
      </div>
      <div className="col-xs-12 center-xs">
        <label>
          By signing up, you agree to our{' '}
          <LinkPopup linkText="Terms and Conditions Agreement">
            <TermsOfUse />{' '}
          </LinkPopup>{' '}
          and{' '}
          <LinkPopup linkText="Privacy Policy">
            <PrivacyPolicy />{' '}
          </LinkPopup>
        </label>
      </div>
      <div className="col-xs-12 center-xs">
        <button type="submit" className="primary">
          Create User
        </button>
      </div>
      <RegisterExtraButtons />
    </div>
  </form>
)

export default RegisterForm
